import styled from '@emotion/styled';

export const Container = styled.div<{ itemsDistance: number }>`
  div:not(:last-child) {
    margin-bottom: ${(p) => `${p.itemsDistance}px`};
  }
`;

